(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gem-homepage"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gem-home')) {
  customElements.define('gem-home', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const opts = {signal:this.controller.signal};
      const panels = [...this.querySelectorAll('[data-demo-panel]')];
      const tabs = [...this.querySelectorAll('[data-demo]')];
      const caption = this.querySelector('[data-demo-caption]');
      const toggle = this.querySelector('[data-play]');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let current = panels[0];
      let manualPaused = false;
      const sync = () => {
        const video = current?.querySelector('video');
        if (video) toggle.textContent = video.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
      };
      const hydrate = panel => {
        const template = panel.querySelector('template');
        if (template) { template.replaceWith(template.content.cloneNode(true)); }
        const video = panel.querySelector('video');
        if (video && !video.dataset.bound) {
          video.dataset.bound = 'true';
          video.setAttribute('aria-label',tabs.find(t=>t.dataset.demo===panel.dataset.demoPanel)?.textContent || '');
          video.muted = true;
          video.addEventListener('play',sync,opts);
          video.addEventListener('pause',sync,opts);
        }
        return video;
      };
      const autoplay = () => {
        const video = current?.querySelector('video');
        if (video && !reduced.matches && !document.hidden && !manualPaused) video.play().catch(()=>{});
      };
      hydrate(current);
      toggle.hidden = false;
      tabs.forEach(tab => tab.addEventListener('click', () => {
        current?.querySelector('video')?.pause();
        current = panels.find(p=>p.dataset.demoPanel===tab.dataset.demo);
        panels.forEach(p=>p.hidden=p!==current);
        tabs.forEach(t=>t.setAttribute('aria-pressed',String(t===tab)));
        hydrate(current);
        caption.textContent = tab.dataset.caption;
        manualPaused = false;
        autoplay();
        sync();
      },opts));
      toggle.addEventListener('click',()=>{
        const video = current?.querySelector('video');
        if (!video) return;
        manualPaused = !video.paused;
        if (video.paused) video.play().catch(()=>{}); else video.pause();
      },opts);
      this.observer = new IntersectionObserver(entries=>{
        entries.forEach(entry=>{ if(entry.isIntersecting) autoplay(); else current?.querySelector('video')?.pause(); });
      },{threshold:0.2});
      this.observer.observe(this.querySelector('.hd-demo'));
      document.addEventListener('visibilitychange',()=>{if(document.hidden) current?.querySelector('video')?.pause();},opts);
      document.addEventListener('shopify:block:select',e=>{
        const tab=tabs.find(t=>t.dataset.demo===e.detail.blockId);if(tab)tab.click();
      },opts);
      sync();
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); this.querySelectorAll('video').forEach(v=>v.pause()); }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if (!customElements.get('gem-kit-summary')) {
  customElements.define('gem-kit-summary', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const section = this.closest('section');
      const picker = section.querySelector('variant-selects');
      const update = id => this.querySelectorAll('[data-kit-variant]').forEach(panel => { panel.hidden = panel.dataset.kitVariant !== String(id); });
      section.addEventListener('change', event => {
        if (event.target.matches('input[name="id"]')) update(event.target.value);
      }, {signal: this.abort.signal});
      if (!picker) return;
      const variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent);
      const selects = [...picker.querySelectorAll('select')];
      picker.addEventListener('change', event => {
        if (!selects.includes(event.target)) return;
        const values = selects.map(select => select.value);
        const index = selects.indexOf(event.target);
        let variant = variants.find(v => v.options.every((value, i) => value === values[i]));
        if (!variant) {
          variant = variants.find(v => v.options[index] === values[index] && v.available) || variants.find(v => v.options[index] === values[index]);
          if (variant) selects.forEach((select,i) => { select.value = variant.options[i]; });
        }
        if (variant) update(variant.id);
      }, {capture:true, signal:this.abort.signal});
      document.querySelectorAll('[data-gem-combination]').forEach(button => {
        button.addEventListener('click', () => {
          const values = button.dataset.gemCombination.split('|');
          const variant = variants.find(v => v.options.every((value,i) => value === values[i]));
          if (!variant) return;
          selects.forEach((select,i) => { select.value = variant.options[i]; });
          selects[0].dispatchEvent(new Event('change', {bubbles:true}));
          picker.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
          selects[0].focus({preventScroll:true});
        }, {signal:this.abort.signal});
      });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}


  } catch(e) { console.error(e); }
})();
})();
